define('SageDotCom/DataLayer/Global/buttons',[
    'jquery',
    'SageDotCom/DataLayer/tealium',
    'SageDotCom/DataLayer/Events/exitLinkClick',
    'SageDotCom/DataLayer/Events/buttonClick',
    'SageDotCom/DataLayer/Events/internalLinkClick',
    'SageDotCom/DataLayer/Events/fileDownload',
    'SageDotCom/DataLayer/Util/urlHelper',
    'SageDotCom/DataLayer/Events/loginStart',
    'SageDotCom/DataLayer/Events/ctaClick',
    'SageDotCom/DataLayer/Events/skinnyBannerClick'
],
    function ($, analytics, exitLinkEvent, buttonClickEvent, internalLinkClickEvent, fileDownloadEvent, urlHelper, loginStartEvent, ctaClick, skinnyBannerClick) {
        function globalButtonTracking() { }

        globalButtonTracking.prototype.initialize = function initialize() {
            //Cta click event:
            $("a.cta_click, button.cta_click").on("click",
                function (event) {
                    var data = ctaClick.GenerateEventMetadata(event.currentTarget);
                    analytics.event(data);
                });

            $(".cta_click > a, .cta_click > button").on("click",
                function (event) {
                    var data = ctaClick.GenerateEventMetadata(event.currentTarget.parentElement);
                    analytics.event(data);
                });

            $(".score-button:not([data-xpr-state], [data-tracking]), .login-trigger, .btn:not([data-xpr-state], [data-tracking]), .sage-video-component:not([data-xpr-state], [data-tracking]), button.bank-feed-load-more")
                .not("footer .score-button, .sticky-navigation a, .select-anchor, .free-trial-form :submit, header .score-button, .customer-success-filter-button.prevent-tracking")
                .each(function (key, value) {
                    if (value.classList.contains("login-trigger")) {
                        value.addEventListener('click',
                            function (event) {
                                var data = loginStartEvent.GenerateEventMetadata(event.currentTarget);
                                analytics.event(data);
                            });
                        value.setAttribute('data-tracking', loginStartEvent.getName());
                    }
                    // internal URL if hostname is blank or matches current browser URL
                    else if (!value.hostname || !value.hostname.length || location.hostname.toLowerCase() === value.hostname.toLowerCase()) {
                        // handle file download vs internal link click
                        var fileTester = urlHelper.isFile(value.href);
                        if (fileTester.isFile === true && fileTester.fileName) {
                            value.addEventListener('click', function (event) {
                                var data = fileDownloadEvent.GenerateEventMetadata(event.currentTarget, fileTester.fileName);
                                analytics.event(data);
                            });

                            value.setAttribute('data-tracking', fileDownloadEvent.getName());
                        }
                        // check if this is score ccf button
                        else if (!value.href) {
                            value.addEventListener('click',
                                function (event) {
                                    if (event.currentTarget.classList.contains("sage-video-component")) {
                                        var data = internalLinkClickEvent.GenerateEventMetadata(event.currentTarget);
                                        data.event_label = "video overlay";
                                        data.event_name_level_2 = "video overlay";
                                        analytics.event(data);
                                    } else {
                                        var data = buttonClickEvent.GenerateEventMetadata(event.currentTarget);
                                        analytics.event(data);
                                    }
                                });
                            value.setAttribute('data-tracking', buttonClickEvent.getName());
                        } // otherwise this is internal link
                        else {
                            value.addEventListener('click',
                                function (event) {
                                    if (event.currentTarget.classList.contains("clickable-area-button") || event.currentTarget.classList.contains("lInk-button")) {
                                        var data = internalLinkClickEvent.GenerateEventMetadata(event.currentTarget);
                                        analytics.event(data);
                                        value.setAttribute('data-tracking', internalLinkClickEvent.getName());
                                    }
                                    else {
                                        var data = buttonClickEvent.GenerateEventMetadata(event.currentTarget);
                                        analytics.event(data);
                                        value.setAttribute('data-tracking', buttonClickEvent.getName());
                                    }
                                });
                        }
                    } // external URLv
                    else {
                        value.addEventListener('click',
                            function (event) {
                                var data = exitLinkEvent.GenerateEventMetadata(event.currentTarget);
                                analytics.event(data);
                            });
                        value.setAttribute('data-tracking', exitLinkEvent.getName());
                    }
                });

            $(".skinny-banner .integrated-countdown-timer").on("click", function (event) {
                var data = skinnyBannerClick.GenerateEventMetadata(event.currentTarget);
                analytics.event(data);
            });
        }

        return new globalButtonTracking();
    });
